import { createFileRoute, Link } from "@tanstack/react-router";
import hayedoImg from "@/assets/blog/hayedo.jpg";
import sierraImg from "@/assets/blog/sierra-norte.jpg";
import casaImg from "@/assets/blog/casa-grupos.jpg";
import pueblosImg from "@/assets/blog/pueblos-negros.jpg";
import altoReyImg from "@/assets/blog/alto-rey.jpg";
import estrellasImg from "@/assets/blog/estrellas.jpg";

export const Route = createFileRoute("/blog/")({
  head: () => ({
    meta: [
      { title: "Blog · El Pajar de Benito" },
      { name: "description", content: "Rutas, recomendaciones y planes en la Sierra del Alto Rey y los pueblos de Guadalajara." },
      { property: "og:title", content: "Blog · El Pajar de Benito" },
      { property: "og:description", content: "Diario de la casa: rutas por el Alto Rey, pueblos negros, observación de estrellas y planes para descubrir la sierra de Guadalajara." },
      { property: "og:url", content: "/blog" },
    ],
    links: [{ rel: "canonical", href: "https://elpajardebenito.es/blog" }],
  }),
  component: Blog,
});

const posts = [
  { slug: "guia-hayedo-tejera-negra", img: hayedoImg, t: "Hayedo de Tejera Negra: guía completa (parking, ruta y otoño)", d: "Cómo reservar el parking obligatorio, cuándo ir para ver el otoño cobrizo y qué ruta hacer paso a paso." },
  { slug: "que-ver-sierra-norte-guadalajara", img: sierraImg, t: "Qué ver en la Sierra Norte de Guadalajara: fin de semana", d: "Plan completo para 2-3 días: pueblos negros, cumbres, hayedos, miradores y gastronomía serrana." },
  { slug: "casa-rural-grupos-cerca-madrid", img: casaImg, t: "Casa rural para grupos cerca de Madrid: qué buscar", d: "Capacidad real, baños privados, cocina, distancia… los criterios que importan al reservar para un grupo." },
  { slug: "arquitectura-negra", img: pueblosImg, t: "Pueblos negros de Guadalajara: pizarra y tradición", d: "Campillo de Ranas, Majaelrayo y Valverde de los Arroyos: la ruta clásica por la arquitectura negra." },
  { slug: "subida-alto-rey", img: altoReyImg, t: "Subir al Pico Alto Rey: ruta paso a paso desde Bustares", d: "Una de las cumbres más emblemáticas de Guadalajara, en un día. Ruta circular de 8 km a 1.852 m." },
  { slug: "estrellas-alto-rey", img: estrellasImg, t: "Observar estrellas en la Sierra del Alto Rey", d: "Cuándo ir, qué llevar y dónde mirar para ver la Vía Láctea en uno de los mejores cielos del centro peninsular." },
];

function Blog() {
  return (
    <section className="mx-auto max-w-5xl px-4 py-20 md:px-6 md:py-28">
      <p className="text-xs uppercase tracking-[0.28em] text-accent">Diario</p>
      <h1 className="mt-3 font-serif text-4xl text-foreground md:text-5xl">Blog</h1>
      <p className="mt-5 max-w-2xl text-muted-foreground">Historias, rutas y recomendaciones para vivir la Sierra del Alto Rey como un vecino más.</p>
      <div className="mt-14 grid gap-10 md:grid-cols-2">
        {posts.map((p) => (
          <article key={p.slug} className="group">
            <Link to="/blog/$slug" params={{ slug: p.slug }} className="block overflow-hidden rounded-xl">
              <img
                src={p.img}
                alt={p.t}
                width={1024}
                height={1024}
                loading="lazy"
                className="aspect-[16/10] w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
            </Link>
            <h2 className="mt-5 font-serif text-2xl text-foreground">
              <Link to="/blog/$slug" params={{ slug: p.slug }} className="hover:text-primary">{p.t}</Link>
            </h2>
            <p className="mt-2 text-muted-foreground">{p.d}</p>
            <Link to="/blog/$slug" params={{ slug: p.slug }} className="mt-4 inline-block border-b border-primary pb-0.5 text-sm font-medium text-primary hover:border-accent hover:text-accent">Leer artículo →</Link>
          </article>
        ))}
      </div>
    </section>
  );
}